import React, { createContext, useContext } from 'react';
import { useNotifications } from '../hooks/useNotifications';
import NotificationContainer from '../components/common/NotificationContainer';

const NotificationContext = createContext();

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    // Restituisce un context di fallback invece di lanciare errore
    console.warn('useNotificationContext used outside NotificationProvider, using fallback');
    return {
      showSuccess: (msg) => console.log('SUCCESS:', msg),
      showError: (msg) => console.error('ERROR:', msg),
      showWarning: (msg) => console.warn('WARNING:', msg),
      notifications: [],
      addNotification: () => {},
      removeNotification: () => {}
    };
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const notificationHook = useNotifications();

  return (
    <NotificationContext.Provider value={notificationHook}>
      {children}
      {/* NotificationContainer disabilitato - usiamo solo NotificationBell */}
      {/* <NotificationContainer
        notifications={notificationHook.notifications}
        onRemove={notificationHook.removeNotification}
        onAction={(notificationId, action) => {
          // Gestisce le azioni delle notifiche
          if (action.action) {
            action.action();
          }
        }}
      /> */}
    </NotificationContext.Provider>
  );
};
